<div class="user-overview container">
  <div class="d-flex justify-content-between">
    <h2 class="page-header">{{ tableTitle }}</h2>
    <div class="btn-wrapper d-flex align-items-center">
      <button class="button" type="button" mat-button (click)="createUser()">
        <i class="fa fa-plus"></i>
        {{ newUserLabel }}
      </button>
    </div>
  </div>

  <div class="table-container panel">
    <div class="example-table-container">
      <div
        *ngIf="loading"
        class="table-loader-overlay"
        style="margin-top: 55px; "
      >
        <div style="margin-top: 145px; align-self: center">
          <mat-spinner
            style="margin:auto;"
            color="primary"
            diameter="75"
          ></mat-spinner>
        </div>
      </div>
      <table
        mat-table
        [dataSource]="users"
        class="example-table"
        matSort
        matSortActive="firstName"
        matSortDisableClear="true"
        matSortDirection="asc"
        width="100%"
      >
        <ng-container matColumnDef="firstName">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex">
              <div class="text-middle">
                <b>Voornaam</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('firstName')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.firstName }}</td>
        </ng-container>

        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex">
              <div class="text-middle">
                <b>Achternaam</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('lastName')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.lastName }}</td>
        </ng-container>
        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef>
            <b>Toegewezen rol</b>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngFor="let role of row.roles">
              {{ role.name === 'ROLE_ADMIN' ? 'Admin' : '' }}</ng-container
            >
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>
            <b>Email</b>
          </th>
          <td mat-cell *matCellDef="let row">{{ row.email }}</td>
        </ng-container>

        <ng-container matColumnDef="company">
          <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex">
              <div class="text-middle">
                <b>Bedrijf</b>
              </div>
              <filter-input
                [filterObject]="getFilterForKey('userContactCompany')"
                (click)="$event.preventDefault() && $event.stopPropagation()"
                (toggleFilterEmitter)="toggleFilter($event)"
                (filterValueChanged)="onFilterValueChange($event)"
              ></filter-input>
            </div>
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.companies != null">
              <div
                class="line-height in-the-middle-left"
                *ngFor="let company of row.companies"
              >
                {{ company }}
              </div>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="employee">
          <th mat-header-cell *matHeaderCellDef>
            <b>Rollen</b>
          </th>
          <td mat-cell *matCellDef="let row">
            <div *ngIf="!row.employee">
              Geen werknemer
            </div>
            <div *ngIf="row.employee">
              <div *ngFor="let type of row.employee.types">
                {{ translateType(type) }}
              </div>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastLogin">
          <th mat-header-cell *matHeaderCellDef>
            <b>Laatste login</b>
          </th>
          <td mat-cell *matCellDef="let row">
            {{ formatDate(row.lastLogin) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="star" stickyEnd>
          <th mat-header-cell *matHeaderCellDef></th>
          <td
            mat-cell
            *matCellDef="let element"
            (click)="$event.stopPropagation()"
          >
            <mat-menu #actionMenu="matMenu">
              <button mat-menu-item (click)="editRow(element)">
                Bewerken
              </button>
              <button mat-menu-item (click)="impersonate(element)">
                Nabootsen
              </button>
              <button mat-menu-item (click)="deleteRow(element)">
                Verwijderen
              </button>
            </mat-menu>

            <div class="text-middle">
              <mat-icon
                class="fa-2x center-menu-buttons"
                [matMenuTriggerFor]="actionMenu"
                >more_vert</mat-icon
              >
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          (click)="editRow(row)"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>
      </table>
    </div>

    <mat-paginator
      [length]="totalItems"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
    ></mat-paginator>
  </div>
</div>
